__turbopack_context__.v({
  "button": "styles-module-scss-module__sIfPla__button",
  "container": "styles-module-scss-module__sIfPla__container",
  "content": "styles-module-scss-module__sIfPla__content",
  "copyright": "styles-module-scss-module__sIfPla__copyright",
  "ctaButton": "styles-module-scss-module__sIfPla__ctaButton",
  "enter": "styles-module-scss-module__sIfPla__enter",
  "exit": "styles-module-scss-module__sIfPla__exit",
  "fade-in": "styles-module-scss-module__sIfPla__fade-in",
  "fade-out": "styles-module-scss-module__sIfPla__fade-out",
  "fade-out-80": "styles-module-scss-module__sIfPla__fade-out-80",
  "intro": "styles-module-scss-module__sIfPla__intro",
  "introRoot": "styles-module-scss-module__sIfPla__introRoot",
  "outline": "styles-module-scss-module__sIfPla__outline",
  "outlineGray": "styles-module-scss-module__sIfPla__outlineGray",
  "primary": "styles-module-scss-module__sIfPla__primary",
  "slide-in-from-bottom": "styles-module-scss-module__sIfPla__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__sIfPla__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__sIfPla__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__sIfPla__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__sIfPla__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__sIfPla__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__sIfPla__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__sIfPla__slide-out-to-top",
  "snippetGuard": "styles-module-scss-module__sIfPla__snippetGuard",
  "wrapper": "styles-module-scss-module__sIfPla__wrapper",
  "zoom-in": "styles-module-scss-module__sIfPla__zoom-in",
  "zoom-out": "styles-module-scss-module__sIfPla__zoom-out",
});
